import React from 'react';

import { QueueCodes } from '../../../constants/workflows';
import { STAFF_TIMECARDS_LIST_QUERY_KEY } from '../../Organization/Timecards/queryKeys';
import { TimecardsListPage } from '../../shared/timecards';

const QUEUE_CATEGORY = 'StaffTimecardQueueNames';

export const StaffTimecardsList: React.FC = () => {
  return (
    <TimecardsListPage
      title="Timecards"
      queryKeyBase={STAFF_TIMECARDS_LIST_QUERY_KEY}
      displayTypePrefKey="StaffTimecards"
      showOrganization={true}
      showOrganizationFilter={true}
      linkContext="staff"
      queueCategory={QUEUE_CATEGORY}
      priorityQueues={true}
      priorityQueueList={[QueueCodes.APPROVED, QueueCodes.INVOICED]}
    />
  );
};
